import CloseIcon from "@hub/assets/close.svg";
import { BuilderSelectionProps } from "@hub/ui/builder/builder-selection";
import { BuilderSelections } from "@hub/ui/builder/builder-selections";
import React from "react";
import styles from "./options-modal.module.css";

interface OptionsModalProps {
  selections: BuilderSelectionProps[];
  isModalVisible: boolean;
  closeModal: () => void;
}

export const OptionsModal: React.FC<OptionsModalProps> = ({
  selections,
  isModalVisible,
  closeModal,
}) => {
  return (
    <div
      className={`${styles.filtersModal} ${
        isModalVisible ? styles.open : styles.closed
      }`}
    >
      <div className={styles.header}>
        <button className={styles.closeButton} onClick={closeModal}>
          <CloseIcon />
        </button>
      </div>
      <div className={styles.content}>
        <BuilderSelections selections={selections} />
      </div>
    </div>
  );
};
